module.exports = __webpack_public_path__ + "img/c.6ad770c8.png";